<template>
    <app-layout>
        <div class="container pt-12">
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                {{ $t("profile") }}
            </h2>
        </div>

        <div class="container py-12">
            <div class="card py-12 px-4">
                <div class="grid grid-cols-2 gap-4">
                    <!-- email -->
                    <div class="col-span-1 form-group">
                        <label>{{ $t("email") }}</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model.trim="$page.props.user.email"
                            readonly
                        />
                    </div>
                    <div class="col-span-1"></div>

                    <!-- current password -->
                    <div class="col-span-1 form-group">
                        <label>{{ $t("current_password") }}</label>
                        <input
                            id="current_password"
                            type="password"
                            class="form-control"
                            v-model="passwordForm.current_password"
                            ref="current_password"
                            autocomplete="current-password"
                        />
                        <jet-input-error
                            :message="passwordForm.errors.current_password"
                            class="mt-2"
                        />
                    </div>
                    <div class="col-span-1"></div>

                    <!-- new password -->
                    <div class="col-span-1 form-group">
                        <label>{{ $t("password") }}</label>
                        <input
                            id="password"
                            type="password"
                            class="form-control"
                            v-model="passwordForm.password"
                            ref="password"
                            autocomplete="new-password"
                        />
                        <jet-input-error
                            :message="passwordForm.errors.password"
                            class="mt-2"
                        />
                    </div>

                    <!-- confirm password -->
                    <div class="col-span-1 form-group">
                        <label>{{ $t("password_confirmation") }}</label>
                        <input
                            id="password_confirmation"
                            type="password"
                            class="form-control"
                            v-model="passwordForm.password_confirmation"
                            autocomplete="new-password"
                        />
                        <jet-input-error
                            :message="passwordForm.errors.password_confirmation"
                            class="mt-2"
                        />
                    </div>
                </div>

                <!-- message -->
                <div class="pt-4">
                    <h4 v-if="saveOk" class="text-success">{{ $t("save_ok") }}</h4>
                </div>

                <!-- save -->
                <div class="pt-4">
                    <button class="btn btn-primary" @click="updatePassword">
                        {{ $t("save") }}
                    </button>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from "../../Layouts/AppLayout";
import DeleteUserForm from "./DeleteUserForm";
import JetSectionBorder from "../../Jetstream/SectionBorder";
import LogoutOtherBrowserSessionsForm from "./LogoutOtherBrowserSessionsForm";
import TwoFactorAuthenticationForm from "./TwoFactorAuthenticationForm";
import UpdatePasswordForm from "./UpdatePasswordForm";
import UpdateProfileInformationForm from "./UpdateProfileInformationForm";
import JetInputError from "../../Jetstream/InputError";

export default {
    props: ["sessions"],

    components: {
        AppLayout,
        DeleteUserForm,
        JetSectionBorder,
        LogoutOtherBrowserSessionsForm,
        TwoFactorAuthenticationForm,
        UpdatePasswordForm,
        UpdateProfileInformationForm,
        JetInputError,
    },

    data() {
        return {
            saveOk: false,
            passwordForm: this.$inertia.form({
                current_password: "",
                password: "",
                password_confirmation: "",
            }),
        };
    },

    methods: {
        updatePassword() {
            this.passwordForm.put(route("user-password.update"), {
                errorBag: "updatePassword",
                preserveScroll: true,
                onSuccess: () => {
                    this.passwordForm.reset();
                    this.saveOk = true;
                },
                onError: () => {
                    if (this.passwordForm.errors.password) {
                        this.passwordForm.reset(
                            "password",
                            "password_confirmation"
                        );
                        this.$refs.password.focus();
                    }

                    if (this.passwordForm.errors.current_password) {
                        this.passwordForm.reset("current_password");
                        this.$refs.current_password.focus();
                    }
                },
            });
        },
    },
};
</script>
